var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9895 4.41666C15.0181 4.41666 4.90617 14.5286 4.90617 26.5C4.90617 38.4714 15.0181 48.5833 26.9895 48.5833C38.9609 48.5833 49.0728 38.4714 49.0728 26.5C49.0728 14.5286 38.9609 4.41666 26.9895 4.41666ZM26.9895 15.4583C30.8033 15.4583 33.6145 18.2673 33.6145 22.0833C33.6145 25.8993 30.8033 28.7083 26.9895 28.7083C23.1779 28.7083 20.3645 25.8993 20.3645 22.0833C20.3645 18.2673 23.1779 15.4583 26.9895 15.4583ZM15.7138 37.0382C17.6946 34.1232 20.9983 32.1798 24.7812 32.1798H29.1978C32.9829 32.1798 36.2844 34.1232 38.2653 37.0382C35.443 40.0592 31.4393 41.9583 26.9895 41.9583C22.5397 41.9583 18.536 40.0592 15.7138 37.0382Z",
    fill: "#CBC4F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircleIcon);
export default __webpack_public_path__ + "static/media/user-circle-icon.a1dee60bc3b520faa69a1753e9ecc251.svg";
export { ForwardRef as ReactComponent };